import { render, staticRenderFns } from "./DeleteUserConfirmation.vue?vue&type=template&id=74a82b71&"
import script from "./DeleteUserConfirmation.vue?vue&type=script&lang=js&"
export * from "./DeleteUserConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports